import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { VoyagePartComponent } from '../voyage-part-component';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';
import { Voyage } from 'src/app/generated/services/transportation/voyages/voyage';
import { ActivatedRoute, Router } from '@angular/router';
import { VoyageServiceSpa } from 'src/app/generated/services/transportation/voyages/voyageSpa';
import { MessageLevel, PgMessagesService } from 'src/app/shared/services/pg-messages.service';
import { KeycloakService } from 'src/app/authentication/keycloak.service';
import { LookupService } from 'src/app/shared/services/lookup.service';

@Component({
  selector: 'app-charterer',
  templateUrl: './charterer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialOrganisationSelectorComponent,
    MaterialPgButtonComponent,
  ]
})
export class ChartererComponent implements OnInit, VoyagePartComponent {
  @Output() changed: EventEmitter<Voyage> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();
  key = 'Misc-Document';
  _uploadedFileId!: string;
  _selectedVoyage!: Voyage;
  _newUploadedFileId!: string;
  expectedVersion?: number;
  charterer!: Organisation;
  organisations: Organisation[] = [];
  documentTypes: string[] = [];

  constructor(
              private organisationService: OrganisationService,
              private _lookupService: LookupService,
              private _pgMessagesService: PgMessagesService,
              private _keycloakService: KeycloakService,
              private _voyagesService: VoyageServiceSpa,
              private _router: Router,
              private _activatedRoute: ActivatedRoute
  ) {}

  @Input() set fileId(value: string) {
    this._uploadedFileId = value;
  }
  @Input() set data(value: any) {
    this._selectedVoyage = value as Voyage;
  }
  @Input() set updatedFileId(value: string) {
    this._newUploadedFileId = value;
  }
  ngOnInit(): void {
    this._activatedRoute.paramMap.subscribe(async p => {
      this._activatedRoute.queryParams.subscribe(p => {
        this._uploadedFileId = p['fileId'];
      });
      const result = await this._voyagesService.getVoyageById({
        id: p.get('id') || ''
      });

      this._selectedVoyage = result.data || Voyage.create();
      this.expectedVersion = result.version;

      this.organisationService.get().subscribe(organisations => {
        this.organisations = organisations.filter(o => o.properties['isCharterer'] === true);
      // if(this._selectedVoyage.charterer) {
      //   this.charterer = this.organisations.find(o => o.name === this._selectedVoyage.charterer) ?? Organisation.create();
      // }
      });

    });
  }

  saveCharterer() {
    this._selectedVoyage.charterer = this.charterer.name;
    this.updateVoyage(this._selectedVoyage);
  }
  updateVoyage(voyage: Voyage) {
    this._voyagesService.updateVoyage({data: voyage, expectedVersion: this.expectedVersion || 0}).then(() => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Info,
        message: `Updated voyage ${voyage.shipVoyageNo} for ${voyage.vesselName}`,
        topic: 'Voyage'
      });
      this._router.navigate(['vessels/voyage', voyage.id], {
        queryParams: {
          t: new Date().getTime()
        }
      }).then();
    });
  }

  deleteCharterer() {
    if (confirm('Are you sure to delete this document')) {
      this._selectedVoyage.charterer = undefined;
      this.changed.emit(this._selectedVoyage);
    }
  }

  backToVoyage(){
    this._router.navigate(['/vessels/voyage/', this._selectedVoyage?.id,]);
  }
}
